// Plugin for the drag and scroll library.
// Mostly used on the breadcrumb bar, so it works on mobile devices (since breadcrumbs and become long).
// plugins/vue-dragscroll.js
import VueDragscroll from 'vue-dragscroll'

export default defineNuxtPlugin((nuxtApp) => {
  // now available on `nuxtApp.$injected`
  nuxtApp.vueApp.use(VueDragscroll)
})
